import { surveyApi } from 'yxt-biz-pc/packages/api';

// 根据人员ID获取其简要信息
export const postUdpUsers = (data) => {
  return surveyApi.post('users', data);
};
